var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportItIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 422,
    viewBox: "0 0 422 422",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 422,
    height: 422,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.275 102.091L282.572 60.4915C279.858 47.5176 267.14 39.2004 254.166 41.9147L77.4914 78.8764C64.5175 81.5907 56.2003 94.3085 58.9146 107.282L112.053 361.283C114.768 374.257 127.486 382.575 140.459 379.86L317.135 342.899C330.109 340.184 338.426 327.466 335.711 314.493L319.125 235.209",
    stroke: "#24255B",
    strokeWidth: 24,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.816 127.979L236.656 102.279",
    stroke: "#24255B",
    strokeWidth: 24,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.236 173.004L246.076 147.305",
    stroke: "#24255B",
    strokeWidth: 24,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.166 218.131L205.577 202.773",
    stroke: "#24255B",
    strokeWidth: 24,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.899 276.348L192.198 305.972C200.518 311.413 211.673 309.079 217.114 300.759L334.978 120.532",
    stroke: "#3AB14A",
    strokeWidth: 28,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportItIcon);
export default __webpack_public_path__ + "static/media/report-it-icon.631e422b22b624703153e32a31893129.svg";
export { ForwardRef as ReactComponent };